import React from 'react'
import './Page2.css'

export default function Page2() {
    return (
        <div>
            I'M PAGE 2
        </div>
    )
}
